import styles from "../css/LearningReviewGroupCell.module.css";
import LearningReviewGroup from "../model/LearningReviewGroup";

import { ReactComponent as CheckBoxOnIcon } from "../../../img/iconImgAllCheckBoxOn.svg";
import { ReactComponent as CheckBoxOffIcon } from "../../../img/iconImgAllCheckBoxOff.svg";
import classNames from "classnames";
import CorrectOrIncorrectTermsCountView from "../../common/view/CorrectOrIncorrectTermsCountView";
import { LearningAnswerType } from "../model/LearningAnswerType";

interface LearningReviewGroupCellProps {
  item: LearningReviewGroup;
  selectedAnswerTypes: LearningAnswerType[];
  onClickItem: (item: LearningReviewGroup) => void;
}

export default function LearningReviewGroupCell(
  props: LearningReviewGroupCellProps
) {
  const containerClass = classNames(styles.container, {
    [styles.containerSelected]: props.item.isSelected,
  });
  const groupNameClass = classNames(styles.groupNameText, {
    [styles.noGroupText]: props.item.isUnspecifiedGroup,
  });

  return (
    <>
      <div
        className={containerClass}
        onClick={() => {
          props.onClickItem(props.item);
        }}
      >
        <div className={styles.groupNameContainer}>
          {props.item.isSelected && (
            <CheckBoxOnIcon className={styles.checkBoxIcon} />
          )}
          {!props.item.isSelected && (
            <CheckBoxOffIcon className={styles.checkBoxIcon} />
          )}
          <span className={groupNameClass}>{props.item.groupName}</span>
        </div>

        <div className={styles.correctOrIncorrectContainer}>
          <CorrectOrIncorrectTermsCountView
            showing={props.item.totalTermsCount === 0}
            type={undefined}
            termsCount={0}
          />
          <CorrectOrIncorrectTermsCountView
            showing={
              props.item.totalTermsCount !== 0 &&
              props.selectedAnswerTypes.includes(LearningAnswerType.correct)
            }
            type={LearningAnswerType.correct}
            termsCount={props.item.correctTermsCount}
          />
          <CorrectOrIncorrectTermsCountView
            showing={
              props.item.totalTermsCount !== 0 &&
              props.selectedAnswerTypes.includes(LearningAnswerType.incorrect)
            }
            type={LearningAnswerType.incorrect}
            termsCount={props.item.incorrectTermsCount}
          />
        </div>
      </div>
    </>
  );
}
